var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKsm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "78px",
    height: "78px",
    viewBox: "0 0 78 78",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "10.4929716%",
    y1: "0%",
    x2: "92.2525491%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0093ED",
    stopOpacity: 0.1,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F3AB",
    stopOpacity: 0.1,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "10.4929716%",
    y1: "29.0657439%",
    x2: "92.2525491%",
    y2: "70.9342561%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0093ED",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F3AB",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "staker---staking-flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-6",
    transform: "translate(-211.000000, -152.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cosmos-logo-horizontal-dark",
    transform: "translate(212.000000, 153.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.9999365,0 C58.9867462,0 76,17.0131586 76,37.9999365 C76,58.9867462 58.9867462,76 37.9999365,76 C17.0131586,76 0,58.9867462 0,37.9999365 C0,17.0131586 17.0131586,0 37.9999365,0 Z",
    id: "Path",
    strokeOpacity: 0.2,
    stroke: "#00F3AB",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0844697,21.5441814 C61.2473485,20.8449191 60.2492424,19.889829 58.4301136,19.6510565 C56.7236742,19.412284 54.9850379,20.6232017 53.8098485,21.4247952 C52.6346591,22.2263886 50.4130682,24.5800034 49.4954545,25.296321 C48.5778409,26.0126385 46.2274621,26.6777905 42.4443182,29.0825709 C38.6611742,31.4873512 23.8183712,41.5840177 23.8183712,41.5840177 L27.6820076,41.6351832 L10.4566288,51.0325872 L12.1791667,51.0325872 L9.7,53.0280433 C9.7,53.0280433 11.8893939,53.6420297 13.7246212,52.4140568 L13.7246212,52.9768777 C13.7246212,52.9768777 34.2340909,44.4151775 38.1943182,46.6323509 L35.7795455,47.3827788 C35.9888258,47.3827788 39.8846591,47.6556617 39.8846591,47.6556617 C40.0760978,49.3860329 40.9847541,50.9362835 42.3638258,51.8853462 C44.7142045,53.5226435 44.7625,54.426568 44.7625,54.426568 C44.7625,54.426568 43.5390152,54.9552786 43.5390152,55.6204306 C43.5390152,55.6204306 45.3420455,55.0405545 47.0162879,55.09172 C48.0788733,55.1344124 49.1327954,55.3119159 50.1554924,55.6204306 C50.1554924,55.6204306 50.0267045,54.904113 48.4007576,54.426568 C46.7748106,53.949023 45.1649621,52.0729532 44.3761364,51.0496424 C43.3931521,49.7244728 43.142309,47.9484843 43.7160985,46.3765232 C44.2795455,44.8245018 46.2435606,43.9717428 50.3003788,41.7545695 C55.0816288,39.1280718 56.1763258,37.1837813 56.8524621,35.6658703 C57.5285985,34.1479593 58.5267045,31.1291925 59.0901515,29.7136125 C59.7984848,27.8887083 60.667803,26.9165631 61.3922348,26.3366869 C62.1166667,25.7568108 65.3363636,24.4776724 65.3363636,24.4776724 C65.3363636,24.4776724 62.8732955,22.2093334 62.0844697,21.5441814 Z",
    id: "Path",
    fill: "url(#linearGradient-2)",
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKsm);
export default __webpack_public_path__ + "static/media/ksm.bf1ee382a5d221d8ee89153e82087613.svg";
export { ForwardRef as ReactComponent };